import { Component, ReactNode } from 'react';

type Props = {
    children: ReactNode;
};

type State = {
    error: Error | null;
};

export default class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = { error: null };
    }

    static getDerivedStateFromError(error: Error) {
        // eslint-disable-next-line no-console
        console.error(error);
        // Update state so the next render will show the fallback UI.
        return { error };
    }

    componentDidCatch(...x: unknown[]) {
        // eslint-disable-next-line no-console
        console.error(x);
    }

    render() {
        return this.state.error ? (
            <span>
                <div>
                    <b>{this.state.error.name}</b>
                </div>
                <div>{this.state.error.message}</div>
                <div>{this.state.error.stack}</div>
            </span>
        ) : (
            this.props.children
        );
    }
}
